bovoApp.controller('CustomerGroupController', ['$scope', 'CustomerGroup', '$location', '$routeParams', '$filter', '$translate',
  function ($scope, CustomerGroup, $location, $routeParams, $filter, $translate) {
    $scope.deleted = [];

    $scope.all = function () {
      CustomerGroup.all().success(function (data, status, headers, config) {
        $scope.data = data;
      });
    }

    $scope.openDetail = function (item) {
      CustomerGroup.get(item.id).success(function (data, status, headers, config) {
        $('#customerGroupModal').modal('show');
        $scope.customerGroup = data.customerGroup;
        $scope.data.users = data.users;
        $scope.data.companyCustomers = data.companyCustomers;
        $scope.buildCustomerMap();
        $scope.customerSearch = '';
        $scope.customerToAdd = '';
        var datas = $scope.customerGroup.company_customers;
        $scope.customerGroup.company_customers = [];
        datas.forEach(element => {
          $scope.customerGroup.company_customers.push({
            company_customer_id: element.id
          });
        });
      });
    }

    // Cari id -> ad eşlemesi (çip listesinde ad göstermek için)
    $scope.buildCustomerMap = function () {
      $scope.custNameMap = {};
      var list = ($scope.data && $scope.data.companyCustomers) ? $scope.data.companyCustomers : [];
      list.forEach(function (c) {
        $scope.custNameMap[c.id] = c.customer_name;
      });
    }

    $scope.customerName = function (id) {
      return ($scope.custNameMap && $scope.custNameMap[id]) ? $scope.custNameMap[id] : ('#' + id);
    }

    // Arama sonucundan cari ekle (dedupe). Arama metni korunur ki arka arkaya ekleyebilsin;
    // eklenen cari notSelected filtresiyle listeden otomatik düşer.
    $scope.addCustomer = function (id) {
      if (!id) {
        return;
      }
      if (!$scope.customerGroup.company_customers) {
        $scope.customerGroup.company_customers = [];
      }
      var exists = $scope.customerGroup.company_customers.some(function (e) {
        return e.company_customer_id == id;
      });
      if (exists) {
        return;
      }
      $scope.customerGroup.company_customers.push({
        company_customer_id: id
      });
    }

    // Henüz gruba eklenmemiş carileri arama sonuçlarında göster (eklenenleri gizle)
    $scope.notSelected = function (c) {
      if (!$scope.customerGroup || !$scope.customerGroup.company_customers) {
        return true;
      }
      return !$scope.customerGroup.company_customers.some(function (e) {
        return e.company_customer_id == c.id;
      });
    }

    $scope.$on('new_data', function () {
      $('#customerGroupModal').modal('show');
      $scope.new();
    }, true);

    $scope.new = function () {
      CustomerGroup.new().success(function (data, status, headers, config) {
        $scope.data.companyCustomers = data.companyCustomers;
        $scope.data.users = data.users;
        $scope.customerGroup = {
          company_customers: []
        };
        $scope.buildCustomerMap();
        $scope.customerSearch = '';
        $scope.customerToAdd = '';
      });
    }

    $scope.addItem = function () {
      console.log($scope.customerGroup)
      console.log($scope.customerGroup.company_customers)
      $scope.customerGroup.company_customers.push({
        company_customer_id: null,
      });
    }

    $scope.removeItem = function (index) {
      $scope.customerGroup.company_customers.splice(index, 1);
    }

    $scope.delete = function (type) {
      if (type == 'set') {
        $('#delete').modal('show');
      } else if (type == 'delete') {
        CustomerGroup.delete($scope.deleted).success(function (data, status, headers, config) {
          Messenger().post($scope.translate(data.message.toString()));
          for (var i = $scope.deleted.length - 1; i >= 0; i--) {
            var index = $scope.data.customerGroup.indexOf($filter('filter')($scope.data.customerGroup, {
              id: $scope.deleted[i]
            })[0]);
            if (index > -1) {
              $scope.data.customerGroup.splice(index, 1);
            }
          }
          $scope.deleted = [];
          $('#delete').modal('hide');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.postForm = function (user) {
      if ($scope.customerGroup.id) {
        $scope.update();
      } else {
        $scope.save();
      }
    }

    $scope.save = function () {
      if (!$scope.customerGroup.company_customers || $scope.customerGroup.company_customers.length === 0) {
        Messenger().post({
          message: 'Lütfen gruba en az bir cari ekleyin.',
          type: 'error'
        });
        return;
      }
      CustomerGroup.save($scope.customerGroup).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#customerGroupModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.update = function () {
      CustomerGroup.update($scope.customerGroup).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#customerGroupModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.toggleSelection = function toggleSelection(id) {
      var idx = $scope.deleted.indexOf(id);
      if (idx > -1) {
        $scope.deleted.splice(idx, 1);
      } else {
        $scope.deleted.push(id);
      }
    };

  }
]);